import { Link } from 'preact-router/match'
import { connect } from 'react-redux'
import { useEffect } from 'preact/hooks'

import styles from 'components/styles/confirmation'
import { isLoggedIn, selectRemoveRegister } from 'selectors/app'
import Redirect from 'components/common/redirect'
import ResendEmail from './ResendEmail'
import { gaPageView } from 'libs/gaPageView'

const Confirmation = ({ removeRegister, isLoggedIn }) => {
  if (removeRegister || isLoggedIn) {
    return <Redirect to={`${__webpack_public_path__ || '/'}`} />
  }

  useEffect(() => gaPageView(), [])

  return (
    <div className="component">
      <div className="componentBody">
        <div className={styles['confirmation-container']}>
          <div className={styles['confirmation-message']}>
            <div className={styles['confirmation-header']}>
              Your account has been created!
            </div>
            <div className={styles['confirmation-text']}>
              To activate the account, follow the instructions in the email we've sent you
            </div>
            <div className={styles['confirmation-btn__group']}>
              <div className={styles['confirmation-link']}>
                <Link href={`${__webpack_public_path__ || '/'}live`}>
                  Open Channel Guide
                </Link>
              </div>
              <div className={styles['confirmation-link']}>
                <Link href={`${__webpack_public_path__ || '/'}checkout`}>
                  View Offers
                </Link>
              </div>
            </div>
          </div>

          <ResendEmail />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state),
  removeRegister: selectRemoveRegister(state),
})

export default connect(mapStateToProps)(Confirmation)
